// this number is bytes
export const FILE_SIZE_LIMIT_IN_BYTES = 1000000
